import { formatCurrency } from "i18n/utils";

import { currenciesMap } from "../../../../utils/currencies";
import {
  generateCountryText,
  ParserType,
  TRANSACTION_AMOUNT_DICTIONARY,
} from "./common";

import type { Currency } from "../../../../models/Currency";
import type { RiskRuleTransactionAmountAlias } from "../../models/RiskRule";

export const transactionAmountParser: ParserType<RiskRuleTransactionAmountAlias> = (
  rule,
  bankName
) => {
  const { payload, filter, operator } = rule;

  const baseTextPart = "The transaction amount";
  const countryTextPart = generateCountryText({ filter, bankName });
  const currency = currenciesMap.get(payload.currency);
  const conditionTextPart = generateConditionText({
    operator,
    payload,
    currency: currency ?? { id: payload.currency, decimal: 0 },
  });

  return [baseTextPart, countryTextPart, conditionTextPart].join("");
};

const generateConditionText = ({
  operator,
  payload,
  currency,
}: Pick<RiskRuleTransactionAmountAlias, "operator" | "payload"> & {
  currency: Pick<Currency, "id" | "decimal">;
}) => {
  const operatorTranslated = TRANSACTION_AMOUNT_DICTIONARY[operator];

  const amount = formatCurrency({ amount: payload.value, currency });

  return ` was ${operatorTranslated} ${amount}\xa0${payload.currency}`;
};
